// @flow
import * as materialAppearance from './material'
import type { Styles } from '..'

export const PrefixWrapper = (props: Styles) => ({
  ...materialAppearance.PrefixWrapper(props),
  color: `${props.$palette('PRIMARY')}`,
})

export const Label = (props: Styles) => ({
  ...materialAppearance.Label(props),
  color: `${props.$palette('GREEN')}`,
  position: 'initial',
  fontWeight: 'bold',
  fontSize: '14px',
  height: '16px',
  transform: 'initial',
  transformOrigin: 'initial',
})

export const InputWithControls = ({ $palette }: Styles) => ({
  ...materialAppearance.InputWithControls,
  height: '40px',
  margin: '3px 0 0 0',
  border: `1px solid ${$palette('GRAY')}`,
})

export const InputWrapper = {
  display: 'flex',
  flexFlow: 'row nowrap',
  flexGrow: 1,
  flexShrink: 1,
  minWidth: 0,
  maxWidth: '100%',
  alignItems: 'center',
  lineHeight: 'initial',
  marginTop: 0,
  padding: '3px 7px 3px 7px',
}

export const Baseline = {
  display: 'none',
}

export const PostfixWrapper = {
  ...materialAppearance.PostfixWrapper,
  marginRight: 0,
}
